import { css } from "styled-components"

export const MenuWrapping = css`
  display: flex;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
`
